
import { Pie } from 'react-chartjs-2';

export const ReadingType = ({ userReport = null }) => {

    let values = new Array(7).fill(0);
    userReport.books.map((item) => {
        values[0] += item.quiz;
        values[1] += item.report;
        values[2] += item.picture;
        values[3] += item.photo;
        values[4] += item.video;
        values[5] += item.meeting;
        values[6] += item.userbook;
        return item;
    });

    const legendOption = { display: false, labels: { fontColor: '#333' }, position: 'right', };
    const data = {
        labels: ['독서퀴즈: ' + values[0],
        '독서감상문: ' + values[1],
        '독서화: ' + values[2],
        '독서사진: ' + values[3],
        '독서영상: ' + values[4],
        '책이랑나랑: ' + values[5],
        '나도작가다: ' + values[6]
        ],
        datasets: [{
            data: values,
            fontColor: ['#fff', '#fff', '#fff', '#fff', '#FFF', '#fff', '#FFF'],
            backgroundColor: ['#0b86ab', '#37a64b', '#db3450', '#FFBF00', '#D8FF24', '#9b64ed'],
            hoverBackgroundColor: ['#0b86ab', '#37a64b', '#db3450', '#FFBF00', '#D8FF24', '#9b64ed']
        }]
    };


    return (
        <div className="section">
            <h3>독서활동</h3>
            <table>
                <colgroup>
                    <col width="50%" />
                    <col width="50%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            <ul>
                                <li><span className="category">도서수</span><span className="data">{userReport.books.length}</span></li>
                                <li><span className="category">독서퀴즈</span><span className="data">{values[0]}</span></li>
                                <li><span className="category">독서감상문</span><span className="data">{values[1]}</span></li>
                                <li><span className="category">독서화</span><span className="data">{values[2]}</span></li>
                                <li><span className="category">독서사진</span><span className="data">{values[3]}</span></li>
                                <li><span className="category">독서영상</span><span className="data">{values[4]}</span></li>
                                <li><span className="category">책이랑나랑</span><span className="data">{values[5]}</span></li>
                                <li><span className="category">나도작가다</span><span className="data">{values[6]}</span></li>
                            </ul>
                        </td>
                        <td>
                            <Pie width={400} height={130}
                                options={{ responsive: false, maintainAspectRatio: false }}
                                data={data}
                                legend={legendOption} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};